import { useEffect, useCallback } from 'react'

const useClickOutside = (ref, handler, disabled, events) => {
  if (!events) events = [`mousedown`, `touchstart`]

  handler = useCallback(handler, [handler])

  useEffect(() => {
    const detectClickOutside = (event) =>
      ref.current && !ref.current.contains(event.target) && handler()
    if (disabled) {
      return
    }

    for (const event of events)
      document.addEventListener(event, detectClickOutside)

    return () => {
      for (const event of events)
        document.removeEventListener(event, detectClickOutside)
    }
  }, [disabled, events, handler, ref])
}

export default useClickOutside
